export { default as ReportList } from './ReportList';
export { default as ReportEdit } from './ReportEdit';



// WEBPACK FOOTER //
// ./src/modules/report/pages/index.js